import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertCircle } from 'lucide-react';

export const Login = () => {
  const [mode, setMode]         = useState('profile'); // 'profile' | 'admin'
  const [key, setKey]           = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (mode === 'admin') {
      if (!key.trim()) { setError('Введите токен доступа'); return; }
    } else {
      if (!username.trim() || !password) { setError('Введите логин и пароль'); return; }
    }
    setLoading(true);
    try {
      if (mode === 'admin') {
        await login({ adminToken: key.trim() });
      } else {
        await login({ username: username.trim(), password });
      }
    } catch (err) {
      setError(mode === 'admin'
        ? 'Неверный токен — проверьте ADMIN_TOKEN в .env сервера'
        : (err.message || 'Неверный логин или пароль'));
    } finally {
      setLoading(false);
    }
  };

  const tabStyle = (active) => ({
    flex: 1, padding: '8px 0', fontSize: '12px', fontWeight: 600,
    background: active ? 'rgba(129,140,248,0.15)' : 'transparent',
    color: active ? 'var(--brand)' : 'var(--text-3)',
    border: 'none', borderRadius: '8px', cursor: 'pointer',
  });

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div className="bg-image" />
      <div style={{ width: '100%', maxWidth: '380px', position: 'relative', zIndex: 1 }}>

        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '16px',
            background: 'linear-gradient(135deg, #818cf8, #6366f1)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: '16px', fontSize: '24px',
            boxShadow: '0 8px 32px rgba(129,140,248,0.4)',
          }}>⚡</div>
          <p className="text-muted" style={{ fontSize: '13px' }}>Панель управления киосками</p>
        </div>

        {/* Card */}
        <div className="card" style={{ padding: '28px' }}>
          {/* Режим входа */}
          <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', background: 'rgba(255,255,255,0.04)', borderRadius: '10px', padding: '4px' }}>
            <button type="button" style={tabStyle(mode === 'profile')} onClick={() => { setMode('profile'); setError(''); }}>
              Пользователь
            </button>
            <button type="button" style={tabStyle(mode === 'admin')} onClick={() => { setMode('admin'); setError(''); }}>
              Администратор
            </button>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {mode === 'admin' ? (
              <div className="field-wrap">
                <span className="field-prefix">🔒</span>
                <input
                  type="password"
                  placeholder="Admin Token"
                  value={key}
                  onChange={e => setKey(e.target.value)}
                  style={{ paddingLeft: '34px' }}
                  autoFocus
                />
              </div>
            ) : (
              <>
                <div className="field-wrap">
                  <span className="field-prefix">👤</span>
                  <input
                    placeholder="Логин"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    style={{ paddingLeft: '34px' }}
                    autoFocus
                    autoComplete="username"
                  />
                </div>
                <div className="field-wrap">
                  <span className="field-prefix">🔒</span>
                  <input
                    type="password"
                    placeholder="Пароль"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    style={{ paddingLeft: '34px' }}
                    autoComplete="current-password"
                  />
                </div>
              </>
            )}

            {error && (
              <div className="alert alert-error" style={{ fontSize: '12px' }}>
                <AlertCircle size={14} style={{ flexShrink: 0 }} />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{ justifyContent: 'center', padding: '10px', marginTop: '4px' }}
            >
              {loading ? 'Проверка...' : 'Войти →'}
            </button>
          </form>
        </div>

        <p className="text-dim" style={{ textAlign: 'center', fontSize: '11px', marginTop: '18px' }}>
          NKEY Kiosk · Система управления аппаратами
        </p>
      </div>
    </div>
  );
};
